import { Component } from '@angular/core';
import { INPUT_VALUE_COVER_TYPE_SOFT } from '@shared/common/product';
import type { TBookAlias, TBookCover } from '@shared/jp/product';
import type { IBookPreview } from '@shared/jp/data/products';
import { getDiscount, getShippingDiscount } from '@shared/jp/discount/utils';
import { EGiftOrderType } from '@shared/common/gift';
import { REGION_NAME_ENGLISH_DEFAULT } from '@shared/jp/shipping/constants';
import { DiscountService } from '@studiobuki/web-core/lib/discount';
import { ProductionService } from 'src/app/services/production.service';
import { BehaviorSubject, combineLatest, of } from 'rxjs';
import { map } from 'rxjs/operators';
import type { TShippingMethod } from '@shared/jp/shipping/interfaces';
import { GiftBooks } from '../gift-buy-page/gift-buy-page.data';

@Component({
  templateUrl: './gift-buy-special-page.component.html',
  styleUrls: ['./gift-buy-special-page.component.scss'],
})
export class GiftBuySpecialPageComponent {
  get alias() {
    return this._alias$.value;
  }

  set alias(value: TBookAlias | undefined) {
    this._alias$.next(value);
  }

  private _alias$ = new BehaviorSubject<TBookAlias | undefined>(undefined);

  public cover: TBookCover = INPUT_VALUE_COVER_TYPE_SOFT;

  /**
   * mapped with adding `SHIPPING_REGULAR_PRICE` to each `IBookPrice['value']`
   */
  public readonly Books: IBookPreview[] = GiftBooks;

  public readonly EGiftOrderType = EGiftOrderType;

  get book(): IBookPreview | undefined {
    const { alias, Books: _Books } = this;

    return alias && _Books.find((b) => b.alias === alias);
  }

  public shipping$ = this._production.getShippingRegular$(
    of({ booksCount: 1, regionName: REGION_NAME_ENGLISH_DEFAULT }),
  );

  public discount$ = combineLatest([
    this._discount.activeDiscountCampaign$,
    this._alias$,
  ]).pipe(
    map(
      ([discountCampaign, alias]) =>
        discountCampaign && alias && getDiscount(discountCampaign, alias),
    ),
  );

  public shippingDiscount$ = combineLatest([
    this._discount.activeDiscountCampaign$,
    this.shipping$,
  ]).pipe(
    map(
      ([discountCampaign, shipping]) =>
        discountCampaign &&
        getShippingDiscount(discountCampaign, shipping.id as TShippingMethod),
    ),
  );

  constructor(
    private _production: ProductionService,
    private _discount: DiscountService,
  ) {}
}
